@if (isScrolled || isHome) {
  <ion-header class="scroll-header">
    <ion-toolbar class="scroll-nav ion-hide-sm-down">
      <div class="content-wrapper navigation-wrapper">
        <app-logo slot="start"></app-logo>

        <div class="nav-filter">
          <app-header-filter></app-header-filter>
        </div>
        <ion-button color="clear" slot="end" size="small" [routerLink]="['/submit-your-property']">{{ 'header.list_property' | translate }}</ion-button>
        <div class="expandable-button-wrapper">
          <ion-buttons class="expanded-v2" [class.expanded]="themeService.toggleAccessibility">
            <div class="flex accessibility">
              <div class="expanded-access" [class.expanded]="themeService.toggleAccessibility">
                <ion-buttons>
                  <ion-button (click)="themeService.accessibilityApply()" aria-label="Increase font size">A</ion-button>
                  <ion-button (click)="themeService.accessibilityApply()" aria-label="Normal font size">A</ion-button>
                  <ion-button (click)="themeService.accessibilityApply()" aria-label="Decrease font size">A</ion-button>
                </ion-buttons>
              </div>
              <ion-buttons>
                <ion-button (click)="themeService.toggleAccessibility = !themeService.toggleAccessibility" aria-label="{{ 'header.accessibility' | translate }}"><ion-icon name="accessibility"></ion-icon></ion-button>
                <div class="toggle-wrapper">
                  <ion-button aria-label="{{ 'header.toggle_theme' | translate }}"><ion-icon name="moon-outline"></ion-icon></ion-button>
                  <ion-toggle aria-label="{{ 'header.toggle_theme' | translate }}" [(ngModel)]="themeService.themeToggle" (ionChange)="themeService.toggleChange($event)"><ion-icon name="moon-outline"></ion-icon></ion-toggle>
                </div>
              </ion-buttons>
            </div>
          </ion-buttons>
          <ion-menu-button menu="mainNav"></ion-menu-button>
          <ion-buttons>
            @if (authService.auth.currentUser) {
            <ion-button [routerLink]="['/profile', 'me']">
              <ion-icon name="person"></ion-icon>
            </ion-button>
            } @else {
              <ion-button [routerLink]="['/user/login']">
                <ion-icon name="person"></ion-icon>
              </ion-button>
            }
          </ion-buttons>
        </div>
      </div>
    </ion-toolbar>
  </ion-header>
} @else {
  <ion-header ngSkipHydration class="main-header ion-hide-sm-down" [class.fill]="filled()" [class.inner]="isScrolled" [class.home]="isHome" [lang]="languageService.lang()">
    <div class="header-top-bar">
      <div class="content-wrapper flex ion-justify-content-between">
        <div class="sm-links" [class.filled]="filled()">
          @for (sm of smLinks; track sm) {
            <a [href]="sm?.link" aria-label="Satel | Properties in Riyadh" target="_blank"><ion-icon [name]="sm?.icon"></ion-icon></a>
          }
        </div>
        <div class="top-links" [class.filled]="filled()">
          @if (authService.auth.currentUser) {
            <a [routerLink]="['/profile', 'me']">{{ commonTextService.commonTexts()?.buttonTexts?.myProfile }}</a>
          } @else {
            <a [dir]="languageService.dir()" [routerLink]="['/user/login']">{{ commonTextService.commonTexts()?.buttonTexts?.login }} / {{ commonTextService.commonTexts()?.buttonTexts?.register }}</a>
          }
          <a [dir]="languageService.dir()" [routerLink]="['/submit-your-property']">{{ commonTextService.commonTexts()?.buttonTexts?.submitYourProperty }}</a>
          <div class="flex accessibility">
            <div class="expanded-access" [class.expanded]="themeService.toggleAccessibility">
              <ion-buttons>
                <ion-button (click)="themeService.accessibilityApply()" aria-label="Increase font size">A</ion-button>
                <ion-button (click)="themeService.accessibilityApply()" aria-label="Normal font size">A</ion-button>
                <ion-button (click)="themeService.accessibilityApply()" aria-label="Decrease font size">A</ion-button>
              </ion-buttons>
            </div>
            <ion-buttons>
              <ion-button (click)="themeService.toggleAccessibility = !themeService.toggleAccessibility" aria-label="{{ 'header.accessibility' | translate }}"><ion-icon name="accessibility"></ion-icon></ion-button>
              <div class="toggle-wrapper">
                <ion-button aria-label="{{ 'header.toggle_theme' | translate }}"><ion-icon name="moon-outline"></ion-icon></ion-button>
                <ion-toggle aria-label="{{ 'header.toggle_theme' | translate }}" [(ngModel)]="themeService.themeToggle" (ionChange)="themeService.toggleChange($event)"><ion-icon name="moon-outline"></ion-icon></ion-toggle>
              </div>
            </ion-buttons>
          </div>
        </div>
      </div>
    </div>
    <div class="main-navigation">
      <ion-toolbar>
        <div class="content-wrapper navigation-wrapper">
          <app-logo color="white" [innerPage]="filled()"></app-logo>
          <div class="flex align-items-center">
            <nav>
              @for (link of navigationContent?.navigationLinks; track link) {
                @if (link.links) {
                  <a [dir]="languageService.dir()" (click)="openSubMenu($event, link.links)">{{ link.text }} <ion-icon name="caret-down-outline"></ion-icon></a>
                } @else {
                  <a [dir]="languageService.dir()" [routerLink]="[link.link]">{{ link.text }}</a>
                }
              }
            </nav>
            <div>
              <a class="link-button white border ion-hide-sm-down" [class.filled]="filled()" [routerLink]="['/listing/rent']">{{ commonTextService.commonTexts()?.buttonTexts?.rentAProperty ?? 'Submit Your Property' }}</a>
            </div>
          </div>
        </div>
      </ion-toolbar>
    </div>
  </ion-header>
}
<div class="mobile-header ion-hide-sm-up">
  <ion-header [class.inner]="isScrolled" [class.scrolled]="isHome" ngSkipHydration>
    <ion-toolbar>
      @if (showMobilePropertyHeader) {
      <ion-buttons class="ion-hide-sm-up" slot="start">
        <ion-button (click)="goBack()">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
        <ion-buttons slot="end">
          <ion-button id="shareOnSm">
            <ion-icon name="share-social-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-popover trigger="shareOnSm" #popover>
          <ng-template>
            <div class="ion-padding sm-buttons flex ion-justify-content-center">
              <div>
                <p>{{ 'header.share_on' | translate }}</p>
                <ion-buttons>
                  <ion-button class="fb" [url]="generateUrl()" shareButton="facebook"><ion-icon name="logo-facebook"></ion-icon></ion-button>
                  <ion-button class="x" color="dark" [url]="generateUrl()" shareButton="x"><ion-icon name="logo-x"></ion-icon></ion-button>
                  <ion-button class="whatsapp" [url]="generateUrl()" shareButton="whatsapp"><ion-icon name="logo-whatsapp"></ion-icon></ion-button>
                  <ion-button (click)="copyUrl()" color="dark"><ion-icon name="copy-outline"></ion-icon></ion-button>
                </ion-buttons>
              </div>
            </div>
          </ng-template>
        </ion-popover>
      }
      @if (showMobilePropertySearchHeader) {
        <ion-buttons slot="end">
          <ion-menu-toggle menu="filter-menu">
            <ion-button>
              <ion-icon name="options"></ion-icon>
            </ion-button>
          </ion-menu-toggle>
        </ion-buttons>
      }
      <app-logo color="white" [innerPage]="true"></app-logo>
      <ion-button color="clear" slot="end" size="small" [routerLink]="['/submit-your-property']">{{ 'header.list_property' | translate }}</ion-button>
      <ion-menu-button menu="mainNav" slot="end"></ion-menu-button>
    </ion-toolbar>
    @if (showMobilePropertySearchHeader) {
      <app-listing-filter></app-listing-filter>
    }
  </ion-header>
</div>
